import Notification from 'flarum/forum/components/Notification';

export default class AskHumanRefundedNotification extends Notification {
  icon() {
    return 'fas fa-coins';
  }

  href() {
    return '#';
  }

  content() {
    const data = this.attrs.notification.content() || {};
    const amount = data.refundAmount || 0;
    return '导师答疑超时，已退还 ' + amount + ' 星币';
  }

  excerpt() {
    return '你可以在「划词答疑」中重新提问';
  }
}
